module.exports = __webpack_public_path__ + "img/3A16AC2E-9524-44ae-A0DB-D08B765B1E06.ef901ce8.png";